export default {
  pink: '#F72585',
  purple: '#3A0CA3',
  white: '#FFFFFF',
  black: '#000000',
  lightGray: '#C4C4C4',
  darkGray: '#939393',
};
